import React from 'react';

const BenefitsSection = ({ title, list }) => {
    return (
        <div>
            <div className='sizedbox py-2 mt-5' style={{ background: "var(--primary-gradient-10)", alignItems: "center" }}>
                <h2>{title}</h2>
            </div>
            <div className='sizedbox row g-2 mt-4  align-items-stretch'>
                {
                    list.map((item, index) => (
                        <div className='col-12 col-md-3 p-4' style={{ fontSize: "24px", fontWeight: "400", lineHeight: "30px" }}>
                            <p>{(index + 1).toString().padStart(2, '0')}</p>
                            <p>{item.title}</p>
                            <p style={{ fontSize: "18px", fontWeight: "400", lineHeight: "24px", textAlign: "justify" }}>{item.desc}</p>
                        </div>
                    ))
                }
            </div>
        </div>
    );
}

export default BenefitsSection;